
export default (event,setState) => {
    if(event?.target?.id === 'toggle-modal' || event.target.tagName === 'path'){
        setState(false)
    }
}